// used in cases where we are passing HTML from the BE response into accessibility attributes
// such as aria-label and title, helper to prevent screen readers from reading out HTML
export function extractHTMLInnerText(html) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .documentElement.textContent;
}
